import { render, staticRenderFns } from "./historyTrack.vue?vue&type=template&id=6bc24bd6&"
import script from "./historyTrack.vue?vue&type=script&lang=js&"
export * from "./historyTrack.vue?vue&type=script&lang=js&"
import style0 from "./historyTrack.vue?vue&type=style&index=0&id=6bc24bd6&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports